import { State as AdminState } from '../reducers/admin-reducer';
import { Selector } from '@ngrx/store';
export const getIsActive: Selector<AdminState, boolean> = (state: AdminState) => state.isActive;
export const getActivePage: Selector<AdminState, string> = (state: AdminState) => state.activePage;
